import { j as o } from "./jsx-runtime-721af1ab.js";
import { B as a } from "./chunk-KRPLQIP4-1ae0870d.js";
import { q as p, u, i as c, g as i } from "./useAccount-9a3d6a50.js";
import "react";
import "./FeatureProvider-eea49aec.js";
import "./TranslationContext-f3729120.js";
import "./myasurion-shared.mixpanel.es.js";
import { D as q, M as E } from "./MobileView-1a8aba0d.js";
import "@emotion/react";
import "./lodash-3345fe65.js";
import "@emotion/styled";
import "./domains-6461a203.js";
import "@tanstack/react-query";
import "./myasurion-shared.carrier.es.js";
import "mixpanel-browser";
import "@chakra-ui/react";
const M = ({
  headerComponent: e,
  bypass: t = !1,
  children: n
}) => {
  const [s] = p({ profileId: "", userId: "" }), [m] = u({ authorization: "", token: "", id: "" }), r = c(s, m);
  return t || r || (console.log(`Unauthorized user redirecting to ${i("/login")}`), window.location.href = i("login")), /* @__PURE__ */ o.jsx(o.Fragment, { children: (t || r) && /* @__PURE__ */ o.jsxs(a, { id: "myasurion-protected-layout", children: [
    e,
    n
  ] }) });
};
export {
  q as DesktopView,
  E as MobileView,
  M as ProtectedLayout
};
